<template>
    <div class="container-xl">
        <main class="py-4">
            <div class="row g-3 mb-4 align-items-center justify-content-between">
                <div class="col-auto">
                    <h1 class="app-page-title mb-0">{{ __('form.manage-forms-title') }}</h1>
                    <div class="intro">Type <code>???</code> voor uitleg over smart search.</div>
                </div>
            </div>

            <div class="row g-3 mb-4 align-items-center justify-content-between">
                <div class="col-auto">
                    <div class="page-utilities">
                        <div class="row g-2 align-items-center">
                            <div class="col-auto">
                                <h6 class="mb-0">Filters:</h6>
                                <button class="btn btn-extra-sm btn-success" @click="clearFilters()">reset</button>
                            </div>
                            <div class="col-auto">
                                <input type="text" v-model="filters.smartSearchFilter" v-on:keyup.enter="getForms"
                                    style="width:500px;" class="form-control"
                                    placeholder="Zoek op (bedrijfs)naam of locatie">
                            </div>
                            <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.instructorFilter"
                                    @change="handleFilterChange">
                                    <option value="all">{{ __('schedules.instructorfilter-all') }}</option>
                                    <option v-for="instructor in instructors" v-bind:key="instructor.id"
                                        v-bind:value="instructor.id">{{ instructor.name }}</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.questionnaireFilter"
                                    @change="handleFilterChange">
                                    <option value="all">{{ __('schedules.questionnairefilter-all') }}</option>
                                    <option v-for="questionnaire in questionnaires" v-bind:key="questionnaire.title"
                                        v-bind:value="questionnaire.title">{{ questionnaire.title }}</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.dateFilter" @change="handleFilterChange">
                                    <option value="today">{{ __('schedules.datefilter-today') }}</option>
                                    <option value="yesterday">{{ __('schedules.datefilter-yesterday') }}</option>
                                    <option value="prev7days">{{ __('schedules.datefilter-prev7days') }}</option>
                                    <option value="prev30days">{{ __('schedules.datefilter-prev30days') }}</option>
                                    <option value="thismonth">{{ __('schedules.datefilter-thismonth') }}</option>
                                    <option value="prevmonth">{{ __('schedules.datefilter-prevmonth') }}</option>
                                    <option value="thisyear">{{ __('schedules.datefilter-thisyear') }}</option>
                                    <option value="prevyear">{{ __('schedules.datefilter-prevyear') }}</option>
                                    <option value="all">{{ __('schedules.datefilter-all') }}</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.wasPresentFilter"
                                    @change="handleFilterChange">
                                    <option value="all">{{ __('schedules.waspresentfilter-all') }}</option>
                                    <option value="1">{{ __('schedules.waspresentfilter-true') }}</option>
                                    <option value="false">{{ __('schedules.waspresentfilter-false') }}</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.hasPassedFilter" @change="handleFilterChange">
                                    <option value="all">{{ __('schedules.haspassedfilter-all') }}</option>
                                    <option value="1">{{ __('schedules.haspassedfilter-true') }}</option>
                                    <option value="false">{{ __('schedules.haspassedfilter-false') }}</option>
                                    <option value="null">{{ __('schedules.haspassedfilter-null') }}</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.webhookSentFilter"
                                    @change="handleFilterChange">
                                    <option value="all">{{ __('schedules.webhooksentfilter-all') }}</option>
                                    <option value="1">{{ __('schedules.webhooksentfilter-true') }}</option>
                                    <option value="false">{{ __('schedules.webhooksentfilter-false') }}</option>
                                    <option value="null">{{ __('schedules.webhooksentfilter-null') }}</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.downloadsFilter" @change="handleFilterChange">
                                    <option value="all">{{ __('schedules.downloadsfilter-all') }}</option>
                                    <option value="eq0">{{ __('schedules.downloadsfilter-eq0') }}</option>
                                    <option value="gt0">{{ __('schedules.downloadsfilter-gt0') }}</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <select class="form-select w-auto" v-model="filters.sort" @change="handleFilterChange">
                                    <option value="date-desc">{{ __('schedules.sortfilter-date-desc') }}</option>
                                    <option value="date-asc">{{ __('schedules.sortfilter-date-asc') }}</option>
                                    <option value="companyname-desc">{{ __('schedules.sortfilter-companyname-desc') }}
                                    </option>
                                    <option value="companyname-asc">{{ __('schedules.sortfilter-companyname-asc') }}
                                    </option>
                                    <option value="location-desc">{{ __('schedules.sortfilter-location-desc') }}
                                    </option>
                                    <option value="location-asc">{{ __('schedules.sortfilter-location-asc') }}</option>
                                </select>
                            </div>
                            <div class="col-auto" v-if="checkedBatchPdfDownloads.length > 1">
                                <a class="btn btn-sm app-btn-primary" @click="downloadBatchPdf()" href="#">Download {{
                                    checkedBatchPdfDownloads.length }} formulieren in 1 ZIP</a>
                                <a class="btn btn-sm app-btn-secondary" @click="deselectAll()" href="#">wis selectie</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 mb-2" v-if="forms.length > 0">
                    <div class="app-card app-card-orders-table shadow-sm mb-5">
                        <div class="app-card-body">
                            <div class="table-responsive">
                                <table class="table app-table-hover mb-0 text-left">
                                    <thead>
                                        <tr>
                                            <th class="cell"> <input type="checkbox" v-model="selectAll"
                                                    @click="select()" /></th>
                                            <th class="cell">{{ __('form.company-name') }}</th>
                                            <th class="cell">{{ __('form.participant-name') }}</th>
                                            <th class="cell">{{ __('form.instructor-name') }}</th>
                                            <th class="cell">{{ __('form.location') }}</th>
                                            <th class="cell">{{ __('form.session-date') }}</th>
                                            <th class="cell">{{ }}</th>
                                            <th class="cell" align="right"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="form in forms" :key="form.id">
                                            <td class="cell">
                                                <input type="checkbox" :value="form.id" id="batchPdf"
                                                    v-model="checkedBatchPdfDownloads" @change='updateCheckall()'>
                                                <span v-if="form.was_present" :class="['passed-dot', {
                                                    'passed-true': form.has_passed == true,
                                                    'passed-false': form.has_passed == false
                                                }]">
                                                </span>
                                                <span v-else class="notpresent-dot"></span>
                                            </td>
                                            <td class="cell">{{ form.company_name }}<br><i>{{ form.title }}</i></td>
                                            <td class="cell">{{ form.participant_name }}<br><i>{{ form.participant_email
                                            }}</i></td>
                                            <td class="cell">{{ form.user.name }}</td>
                                            <td class="cell">{{ form.location }}</td>
                                            <td class="cell date-cell">{{ form.start_date_formatted }}<br />{{
                                                form.start_time_formatted }}</td>
                                            <td class="cell">
                                                <span v-if="form.is_webhook_sent == 1"
                                                    class="webhooksent-dot webhooksent-true"></span>
                                                <span v-else-if="form.is_webhook_sent == 0"
                                                    class="webhooksent-dot webhooksent-false"></span>
                                                <span v-else class="webhooksent-dot ss"></span>
                                            </td>
                                            <td class="cell action-cell" align="right">
                                                <div class="btn-group-vertical">
                                                    <a class="btn btn-sm btn-outline-success" download="true"
                                                        @click.prevent="download('/forms/get-pdf/' + form.id)">PDF ({{
                                                            form.downloads }}x gedownload)</a>
                                                    <a class="btn btn-sm btn-outline-success"
                                                        :href="'/forms/' + form.id">{{ __('form.form-viewedit') }}</a>
                                                    <a class="btn btn-sm app-btn-danger" href="#"
                                                        @click.prevent="deleteForm(form)">{{ __('form.form-delete')
                                                        }}</a>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <pagination-component :pagination="pagination" @paginate="getForms"></pagination-component>
                </div>

                <div class="col-md-12" v-else>
                    <div class="app-card alert alert-dismissible shadow-sm mb-5 border-left-decoration" role="alert">
                        <div class="inner">
                            <div class="app-card-body p-3 p-lg-4">
                                <h3 class="mb-3">{{ __('form.no-forms-title') }}</h3>
                                <p>{{ __('form.no-forms-text') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <div v-show="showModal" class="modal fade modal-xl" id="help_modal" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="help_modal_label">Hoe werkt de Smart Search?</h5>
                        <button type="button" class="btn-close" aria-label="Close" @click="closeModal"></button>
                    </div>
                    <div class="modal-body">
                        <p>Met de Smart Search Bar kun je eenvoudig zoeken op verschillende velden. Gebruik trefwoorden
                            of filters om de resultaten te verfijnen.</p>
                        <h6>🔍 Beschikbare zoekfilters</h6>
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Filter</th>
                                    <th>Uitleg</th>
                                    <th>Voorbeeld</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>bedrijf:</b></td>
                                    <td>Zoek op bedrijfsnaam</td>
                                    <td><code>bedrijf:Acme</code></td>
                                </tr>
                                <tr>
                                    <td><b>rijder:</b></td>
                                    <td>Zoek op naam van de deelnemer</td>
                                    <td><code>rijder:John Doe</code></td>
                                </tr>
                                <tr>
                                    <td><b>analyse:</b></td>
                                    <td>Zoek op titel van de analyser</td>
                                    <td><code>analyse:rijstijl analyse</code></td>
                                </tr>
                                <tr>
                                    <td><b>locatie:</b></td>
                                    <td>Zoek op trainingslocatie</td>
                                    <td><code>locatie:Amsterdam</code></td>
                                </tr>
                                <tr>
                                    <td><b>datum:</b></td>
                                    <td>Zoek op datum, maand of jaar.<br>Gebruik <code>&lt;</code> of <code>&gt;</code>
                                        om vóór of na een datum te zoeken.</td>
                                    <td>
                                        <code>datum:2024</code> → Alle data in **2024**<br>
                                        <code>datum:2024-08</code> of <code>datum:08-2024</code> → **Augustus 2024**<br>
                                        <code>datum:2024-08-02</code> of <code>datum:02-08-2024</code> → **2 augustus
                                        2024**<br>
                                        <code>datum:&lt;2024</code> → **Alle data vóór 2024**<br>
                                        <code>datum:&gt;2024-08</code> → **Alle data ná augustus 2024**<br>
                                        <code>datum:&lt;2024-08-02</code> → **Alle data vóór 2 augustus 2024**<br>
                                        <code>datum:&gt;02-08-2024</code> → **Alle data ná 2 augustus 2024**
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>project:</b></td>
                                    <td>Zoek op projectcode</td>
                                    <td><code>project:XYZ123</code></td>
                                </tr>
                                <tr>
                                    <td><b>email:</b></td>
                                    <td>Zoek op e-mailadres</td>
                                    <td><code>email:john@example.com</code></td>
                                </tr>
                                <tr>
                                    <td><b>Wildcard (*)</b></td>
                                    <td>Gebruik een sterretje (*) om te zoeken op een deel van een woord</td>
                                    <td>
                                        <code>bedrijf:Ac*</code> → Alle bedrijven die beginnen met "Ac"<br>
                                        <code>rijder:Jo*</code> → Alle rijders met een naam die begint met "Jo"
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>Meerdere filters</b></td>
                                    <td>Combineer filters om specifieker te zoeken</td>
                                    <td><code>bedrijf:Acme rijder:John datum:2024-08</code></td>
                                </tr>
                            </tbody>
                        </table>

                        <h6>ℹ️ Extra tips</h6>
                        <ul>
                            <li>Gebruik <b>zonder filter</b> om in alle velden te zoeken. Bijvoorbeeld:
                                <code>Acme</code> zoekt in bedrijfsnaam, rijder en locatie.
                            </li>
                            <li>Je kunt filters <b>combineren</b> voor een nauwkeurigere zoekopdracht.</li>
                            <li>Voor <b>datumfilters</b> kun je nu ook <code>&lt;</code> (voor een bepaalde datum) en
                                <code>&gt;</code> (na een bepaalde datum) gebruiken.
                            </li>
                            <li>Voor <b>datumfilters</b> kun je het streepje ook weglaten. Bijvoorbeeld
                                <code>202408</code> of <code>20240802</code>.
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="closeModal">Sluiten</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ManageFormsComponent",

    props: {
        instructors: {
            type: Array,
            required: true
        },

        questionnaires: {
            type: Array,
            required: true
        },
    },

    data() {
        return {
            forms: [],
            pagination: {
                current_page: 1
            },
            filters: this.getFiltersFromStorage(),
            checkedBatchPdfDownloads: [],
            selectAll: false
        }
    },

    created() {
        this.getForms();
    },

    watch: {
        'filters.smartSearchFilter'(newValue) {
            if (newValue.toLowerCase().includes("???")) {
                this.openModal();
                this.filters.smartSearchFilter = newValue.replace(/\s*\?\?\?\s*/g, "").trim();
            }

            if (newValue.includes("datum:")) {
                this.filters.dateFilter = "all";
                //this.getForms();
            }

            if (newValue.includes("analyse:")) {
                this.filters.questionnaireFilter = "all";
                //this.getForms();
            }
        }
    },

    mounted() {
        this.help_modal = new bootstrap.Modal(document.getElementById('help_modal'), {});
    },

    methods: {

        openModal() {
            this.help_modal.show();
        },

        closeModal() {
            this.help_modal.hide();
        },

        handleFilterChange() {
            // Use nextTick to ensure v-model has updated before fetching
            this.$nextTick(() => {
                this.getForms();
            });
        },

        getFiltersFromStorage: function (clear = false) {

            if (clear) {
                sessionStorage.removeItem('formfilters');
            } else {
                const storedFilters = sessionStorage.getItem('formfilters');
                if (storedFilters) {
                    try {
                        return JSON.parse(storedFilters);
                    } catch (e) {
                        sessionStorage.removeItem('formfilters');
                    }
                }
            }

            return {
                instructorFilter: 'all',
                questionnaireFilter: 'all',
                dateFilter: 'prev30days',
                smartSearchFilter: '',
                hasPassedFilter: 'all',
                wasPresentFilter: 'all',
                webhookSentFilter: 'all',
                downloadsFilter: 'all',
                sort: 'date-desc'
            }
        },

        clearFilters: function () {
            this.filters = this.getFiltersFromStorage(true);
            this.getForms();
        },

        deselectAll() {
            this.checkedBatchPdfDownloads = [];
            this.selectAll = false;
        },

        select() {
            this.checkedBatchPdfDownloads = [];
            if (!this.selectAll) {
                this.forms.forEach((form, index) => {
                    this.checkedBatchPdfDownloads.push(form.id);
                })
            }
        },

        updateCheckall: function () {
            if (this.forms.length == this.checkedBatchPdfDownloads.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        },

        download(path) {
            window.open(path, "_self");
            setTimeout(() => this.getForms(), 500);
        },

        downloadBatchPdf: function () {

            const formData = new FormData()
            formData.append('formIds', JSON.stringify(this.checkedBatchPdfDownloads))

            axios.post('/forms/generate-filename-for-zipfile', formData)
                .then(response => {
                    let zipfilename = response.data
                    console.log(zipfilename)
                    formData.append('zipfilename', zipfilename)

                    //fire another request (with the just received filename) to make the actual zip
                    axios.post('/forms/download-batch', formData, {
                        responseType: 'blob'
                    })
                        .then(response => {
                            const url = window.URL.createObjectURL(new Blob([response.data]));
                            const link = document.createElement('a');
                            link.href = url;
                            link.setAttribute('download', zipfilename);
                            document.body.appendChild(link);
                            link.click()

                            setTimeout(() => this.getForms(), 500);
                        })
                })
        },

        getForms: function (page = null) {

            if (page) {
                this.pagination.current_page = page;
            }

            sessionStorage.setItem('formfilters', JSON.stringify(this.filters));

            axios.get('/get-forms', {
                params: {
                    page: this.pagination.current_page,
                    datefilter: this.filters.dateFilter,
                    instructorfilter: this.filters.instructorFilter,
                    questionnairefilter: this.filters.questionnaireFilter,
                    smartsearchfilter: this.filters.smartSearchFilter,
                    haspassedfilter: this.filters.hasPassedFilter,
                    waspresentfilter: this.filters.wasPresentFilter,
                    webhooksentfilter: this.filters.webhookSentFilter,
                    downloadsfilter: this.filters.downloadsFilter,
                    sort: this.filters.sort
                }
            })
                .then(response => {
                    console.log("form list refreshed")
                    this.forms = response.data.forms.data
                    this.pagination = response.data.forms
                })
        },

        deleteForm: function (form) {
            Swal.fire({
                title: this.__('actions.confirm'),
                text: this.__('actions.confirm-text'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.__('actions.confirm-yes'),
                cancelButtonText: this.__('actions.confirm-no'),
                showLoaderOnConfirm: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                reverseButtons: true,
                preConfirm: login => {
                    return axios.delete(`/forms/${form.id}`).then(response => {
                        return response.data
                    })
                        .catch(error => {
                            Swal.showValidationMessage(`Something went wrong!: ${error}`)
                        })
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then(result => {
                if (result.value) {
                    Toast.fire({ icon: 'success', title: result.value.message })
                    this.getForms()
                }
            })
        }
    }
}
</script>

<style scoped>
.btn-extra-sm {
    font-weight: 500;
    padding: 0.1rem 0.5rem;
    font-size: 0.70rem;
    text-transform: uppercase;
    color: #fff;
}

.passed-true {
    background-color: #379437 !important;
}

.passed-false {
    background-color: #FF3333 !important;
}

.passed-dot {
    height: 14px;
    width: 14px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
}

.notpresent-dot {
    height: 0;
    width: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 10px solid #A020F0;
    display: inline-block;
}

.webhooksent-true {
    background-color: rgb(26, 59, 167) !important;
}

.webhooksent-false {
    background-color: #FF3333 !important;
}

.webhooksent-dot {
    height: 14px;
    width: 14px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
}

.action-cell {
    width: 165px;
}

.date-cell {
    width: 96px;
}
</style>
